import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMenu,{attrs:{"open-on-hover":"","offset-y":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"menu-wrapper"},'div',attrs,false),on),[_vm._t("menu-activator")],2)]}}],null,true)},[_c('div',{staticClass:"menu"},[_vm._t("menu")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }